(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('magia-sticky-cart')) {
  customElements.define('magia-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.main = document.querySelector('product-info[id^="MainProduct-"]');
      if (!this.main) return;
      this.button = this.querySelector('button');
      this.refresh = () => {
        const buttons = [...this.main.querySelectorAll('product-form .product-form__buttons [type="submit"], product-form .gPreorderBtn')];
        this.target = buttons.find(button => button.getClientRects().length && getComputedStyle(button).visibility !== 'hidden');
        if (!this.target) { this.hidden = true; return; }
        const rect = this.target.getBoundingClientRect();
        this.hidden = rect.bottom >= 0;
        this.button.textContent = this.target.innerText.trim();
        this.button.disabled = this.target.disabled || this.target.getAttribute('aria-disabled') === 'true';
        const price = this.main.querySelector('[id^="price-"] .price--on-sale .price-item--sale, [id^="price-"] .price:not(.price--on-sale) .price__regular .price-item');
        if (price) this.querySelector('[data-sticky-price]').textContent = price.textContent.trim();
      };
      this.onScroll = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); }); };
      this.onClick = () => { if (this.target && !this.button.disabled) this.target.click(); };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll);
      this.observer = new MutationObserver(this.onScroll);
      this.observer.observe(this.main, {subtree:true, childList:true, attributes:true, characterData:true});
      this.refresh();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.button?.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
